import 'reflect-metadata';

import { IMicrositeAppDetailsPageConfig } from 'src/interfaces/page';
import { injectable } from 'inversify';
import { IAppDetailsAppData } from '@orcha/micro-library-core-ui';
import { IAppDetailsService } from './interfaces';
import ApiClient from './api-client';
import { IAppDetailsPageData } from './interfaces/app-details-service.interface';

@injectable()
class AppDetailsService implements IAppDetailsService {
  private micrositeApiClient: ApiClient;

  public constructor() {
    this.micrositeApiClient = new ApiClient(
      process.env.MICROSITE_BFF_API_BASE_URL ?? ''
    );
  }

  public async getAppDetailsPageData(
    tenantId: string,
    packageId: string,
    appId: string,
    language?: string
  ): Promise<IAppDetailsPageData | undefined> {
    const appDetailsApiResponse =
      await this.micrositeApiClient.get<IMicrositeAppDetailsPageConfigWrapper>(
        `tenants/${tenantId}/packages/${packageId}/apps/${appId}/appdetails?language=${language}`
      );

    return {
      app: appDetailsApiResponse.data?.app,
      widgets: appDetailsApiResponse.data?.page.configuredWidgets || [],
    };
  }
}

interface IMicrositeAppDetailsPageConfigWrapper {
  data?: { app: IAppDetailsAppData; page: IMicrositeAppDetailsPageConfig };
  status: string;
}

export default AppDetailsService;
